import { useLocation } from 'react-router-dom';

const useGetParams = () => new URLSearchParams(useLocation().search);

export default useGetParams;
